<template>
<div class="opModal">
    <div class="midTitle text-center" v-if="title">
        <span v-html="title"></span>
    </div>
    <div class="body text-center mt-3">
        <span v-html="text"></span>
        <div class="mt-4 mw-700">
            <div>
                <button type="button" ref="okButton" class="btn btn-block btn-primary" 
                    @click="ok" @keydown.space.prevent="ok" @keydown.enter.prevent="ok">
                    <span v-html="okText"></span>
                </button>
            </div>
            <div class="mt-3">
                <button type="button" class="btn btn-block btn-danger" @click="ko">
                    <span v-html="koText"></span>
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Options({})
export default class ConfirmModal extends Vue {

    @Prop() title: string;
    @Prop() text: string;
    @Prop({
        default: 'OK'
    }) okText: string;
    @Prop({
        default: 'Annulla'
    }) koText: string;
    @Prop() okCallback: () => Promise<any>;
    @Prop() koCallback: () => Promise<any>;

    async ok(){
        if(this.okCallback){
            await this.okCallback();
        }
        this.$emit('close');
    }

    async ko(){
        if(this.koCallback){
            await this.koCallback();
        }
        this.$emit('close');
    }

    mounted(){
        (<HTMLButtonElement>this.$refs.okButton).focus();
    }

}
</script>
<style scoped>

</style>